module.exports = __webpack_public_path__ + "media/banner/banner-3-a9267574.jpg";